"use client";

import Link from "next/link";
import { Badge } from "@/components/ui/badge";
import { ActionIcon } from "@/components/ui/action-icon";
import SearchWidget from "@/components/search/search";
import MessagesDropdown from "@/layouts/messages-dropdown";
import NotificationDropdown from "@/layouts/notification-dropdown";
import ProfileMenu from "@/layouts/profile-menu";
import SettingsButton from "@/components/settings/settings-button";
import HamburgerButton from "@/layouts/hamburger-button";
import Logo from "@/components/logo";
import {
  PiChatCircleDotsFill,
  PiBellSimpleRingingFill,
  PiGearFill,
} from "react-icons/pi";
import cn from "@/utils/class-names";
import Sidebar from "./helium-sidebar";
import { Button, Text } from "rizzui";
import { useSession, signOut } from "next-auth/react";
import { IoExitOutline } from "react-icons/io5";
import getData from "@/functions/getData";
import { apis } from "@/static/apis/apis";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
import useFetch from "@/hooks/fetch/useFetch";
import { use, useEffect, useState } from "react";
import { set } from "lodash";
import motion from "framer-motion";
import ShowInfoModal from "@/components/modal/show-info";
import { TbQuestionMark } from "react-icons/tb";
import { PiCheck } from "react-icons/pi";
import { routes } from "@/config/routes";
import toast from "react-hot-toast";
import postData from "@/functions/postData";
import { useRouter } from "next/navigation";
import putData from "@/functions/putData";
type StateType = {
  data: any | undefined;
  loading: boolean;
  error: any | null;
};
function HeaderMenuRight() {
  const { data: session, status: statusAuth } = useSession();
  const [showModal, setShowModal] = useState(true);
  const axiosAuth = useAxiosAuth();
  const [is_seenChat, setIs_SeenChat] = useState(true) as [boolean, any];
  const [is_seenNotif, setIsSeenNotif] = useState(true) as [boolean, any];
  const [modalNewNotification, setModalNewNotification] = useState<any>([]);

  const getNotif = (res: any) => {
    const modalNewNotific = res.data.filter(
      (item: any) => item.message === "پیشنهاد شما تایید شد" && !item.is_seen
    );
    setModalNewNotification(modalNewNotific);
  };
  const [state, setState] = useFetch((axiosAuth, setState) =>
    getData(apis.notification.mylist, axiosAuth, setState, false, (res) => {
      getNotif(res);
    })
  ) as [StateType, any];
  const [modals, setModals] = useState(<></>);
  let router = useRouter();
  const axios = useAxiosAuth();
  useEffect(() => {
    if (modalNewNotification) {
      // setDataModal();
      setShowModal(true);
    }
  }, [modalNewNotification]);

  useEffect(() => {
    // if (state) {
    //   // if(state.data[0])
    //   const modalNewNotific = state?.data?.filter(
    //     (item: any) => item.message === "پیشنهاد شما تایید شد" && !item.is_seen
    //   );
    //   setModalNewNotification(modalNewNotific);
    // }

    const unseenchat = state?.data?.filter(
      (item: any) => item.status === "chat" && !item.is_seen
    );
    if (unseenchat !== undefined) {
      if (unseenchat.length > 0) {
        setIs_SeenChat(false);
      } else {
        setIs_SeenChat(true);
      }
    }
    const unseennotif = state?.data?.filter(
      (item: any) => item.status !== "chat" && !item.is_seen
    );
    if (unseennotif !== undefined) {
      if (unseennotif.length > 0) {
        setIsSeenNotif(false);
      } else {
        setIsSeenNotif(true);
      }
    }
    let interval = setInterval(() => {
      getData(apis.notification.mylist, axiosAuth, setState, false, (res) => {
        getNotif(res);
      });
    }, 60 * 1000);
    return () => clearInterval(interval);
  }, [state]);
  return (
    <div className="flex flex-grow justify-end gap-2 xs:gap-3 xl:gap-4">
      <MessagesDropdown
        data={state}
        setData={setState}
        setSeen={setIs_SeenChat}
      >
        <ActionIcon
          aria-label="Messages"
          variant="text"
          className={cn(
            "relative h-[34px] w-[34px] overflow-hidden  shadow backdrop-blur-md before:absolute before:h-full before:w-full before:-rotate-45  before:bg-gradient-to-l   dark:bg-gray-100 md:h-9 md:w-9 3xl:h-10 3xl:w-10 "
          )}
        >
          <PiChatCircleDotsFill className="h-[18px] w-auto 3xl:h-5" />
          {!is_seenChat && (
            <Badge
              renderAsDot
              color="success"
              enableOutlineRing
              className="absolute right-1 top-2.5 -translate-x-1 -translate-y-1/4"
            />
          )}
        </ActionIcon>
      </MessagesDropdown>
      {/* <motion.div> */}
      <NotificationDropdown
        data={state}
        setData={setState}
        setSeen={setIsSeenNotif}
      >
        <ActionIcon
          aria-label="Notification"
          variant="text"
          className={cn(
            "relative h-[34px] w-[34px] overflow-hidden  shadow backdrop-blur-md before:absolute before:h-full before:w-full   before:bg-gradient-to-l   dark:bg-gray-100   md:h-9 md:w-9 3xl:h-10 3xl:w-10"
          )}
        >
          <PiBellSimpleRingingFill className="h-[18px] w-auto 3xl:h-5" />
          {!is_seenNotif && (
            <Badge
              renderAsDot
              color="warning"
              enableOutlineRing
              className="absolute right-1 top-2.5 -translate-x-1 -translate-y-1/4"
            />
          )}
        </ActionIcon>
      </NotificationDropdown>
      {/* </motion.div> */}
      <SettingsButton className=" before:absolute before:h-full before:w-full 3xl:h-10 3xl:w-10">
        <PiGearFill className="h-[22px] w-auto animate-spin-slow" />
      </SettingsButton>
      <ProfileMenu />
      {modalNewNotification &&
        modalNewNotification.map((item: any, index: number) => {
          if (item.chatroom !== null)
            toast(
              (t) => {
                return (
                  <div className="flex flex-col gap-3 my-2   items-center">
                    <p>
                      تبریک پیشنهاد شما <b>تایید</b> شد برای ادامه فرایند باید
                      به صفحه گفتوگو با ادمین بروید.
                    </p>
                    <p className="text-gray-400">
                      شما می‌توانید از طریق صفحه{" "}
                      <Link href={routes.dashboard.page} className="underline">
                        میزکار
                      </Link>{" "}
                      به صفحه گفتوگو با ادمین بروید
                    </p>
                    <div className="mr-auto flex flex-row gap-2">
                      <Button
                        size="sm"
                        className=""
                        // variant="text"
                        onClick={() => {
                          toast.dismiss(t.id);
                          putData(
                            apis.notification.seen(item.id),
                            axios,
                            {},
                            undefined,
                            false,
                            () => {}
                          );
                        }}
                      >
                        بعدا خودم می‌روم
                      </Button>
                      <Button
                        size="sm"
                        className=""
                        onClick={() => {
                          toast.dismiss(t.id);
                          putData(
                            apis.notification.seen(item.id),
                            axios,
                            {},
                            undefined,
                            "برو بریم",
                            () => {
                              router.push(routes.chat(item.chatroom));
                            }
                          );
                        }}
                      >
                        بریم
                      </Button>
                    </div>
                  </div>
                );
              },
              {
                id: item.id,
                duration: 100000,
                position: "bottom-right",
              }
            );
        })}
    </div>
  );
}

export default function Header() {
  return (
    <header
      className={
        "sticky top-1 z-50 flex items-center bg-gray-0/80 px-4 py-4 backdrop-blur-xl dark:bg-gray-50/50 md:px-5 lg:mx-6 lg:px-4  xl:mx-4 xl:px-4 2xl:py-5 2xl:pl-6 3xl:px-8 3xl:pl-6 4xl:px-10 4xl:pl-9 rounded-xl"
      }
    >
      <div className="flex w-full max-w-2xl items-center">
        <HamburgerButton
          view={
            <Sidebar className="static w-full xl:p-0 2xl:w-full [&>div]:xl:rounded-none" />
          }
        />
        <div
          aria-label="Site Logo"
          className="me-4 w-9 shrink-0 lg:me-5 xl:hidden"
        >
          <Logo iconOnly={true} />
        </div>
        {/* <SearchWidget /> */}
      </div>

      <HeaderMenuRight />
    </header>
  );
}
